module.exports = __webpack_public_path__ + "9cab25cfa77514c5ea52e8afb9bb765f.svg";